import useQueryParam from 'Shared/hooks/useQueryParam'
import { CLS_MODAL_QUERY_PARAM } from '../constants'
import { useCallback, useMemo } from 'react'

const useSessionStatusModal = () => {
  const { value, setQueryParam, clearQueryParam } = useQueryParam(CLS_MODAL_QUERY_PARAM)

  const shouldDisplayModal = useMemo(() => {
    return !!value
  }, [ value ])

  const closeModal = useCallback(() => {
    clearQueryParam()
  }, [ clearQueryParam ])

  const openModal = useCallback((sessionID) => {
    setQueryParam(sessionID)
  }, [ setQueryParam ])

  return { sessionID: value, shouldDisplayModal, closeModal, openModal }
}

export default useSessionStatusModal
